import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, className = "", delay = 0, y = 28 }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
}

export function SectionHeading({ eyebrow, title, className = "" }) {
    return (
        <div className={className}>
            <Reveal>
                <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-primary">
                    {eyebrow}
                </p>
            </Reveal>
            <Reveal delay={0.08}>
                <h2 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tighter leading-[0.95]">
                    {title}
                </h2>
            </Reveal>
        </div>
    );
}